const MAX_AUDIT_ID_LENGTH = 160;
const AUDIT_ID_CONTROL_PATTERN = /\p{Cc}/u;

/**
 * Mirrors the backend audit-id boundary before a value from the address bar
 * can become an API request. Firestore document ids cannot contain a path
 * separator; controls are rejected as an additional browser-side guardrail.
 */
export function normalizeAuditDeepLinkId(value) {
  if (typeof value !== 'string') return '';
  const auditId = value.trim();
  if (
    !auditId
    || auditId.length > MAX_AUDIT_ID_LENGTH
    || auditId.includes('/')
    || AUDIT_ID_CONTROL_PATTERN.test(auditId)
  ) {
    return '';
  }
  return auditId;
}

export function auditIdFromLocation(locationValue = globalThis.location) {
  const search = typeof locationValue?.search === 'string' ? locationValue.search : '';
  const params = new URLSearchParams(search);
  if (!params.has('audit')) return '';
  return normalizeAuditDeepLinkId(params.get('audit'));
}

/**
 * Called only after authentication and the authoritative tenant-membership
 * probe have succeeded. Delegating to the view's existing openAuditById keeps
 * the deep link on the exact same loading/error/polling path as a user click.
 */
export async function openAuditDeepLink(view, auditId) {
  const normalizedAuditId = normalizeAuditDeepLinkId(auditId);
  if (!normalizedAuditId) return false;
  if (!view || typeof view.openAuditById !== 'function') {
    throw new TypeError('La vista A11yPilot non supporta l\u2019apertura diretta di un audit.');
  }
  await view.openAuditById(normalizedAuditId);
  return true;
}
